import { render, staticRenderFns } from "./Social.vue?vue&type=template&id=2f7f84c2"
import script from "./Social.vue?vue&type=script&lang=js"
export * from "./Social.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f7f84c2')) {
      api.createRecord('2f7f84c2', component.options)
    } else {
      api.reload('2f7f84c2', component.options)
    }
    module.hot.accept("./Social.vue?vue&type=template&id=2f7f84c2", function () {
      api.rerender('2f7f84c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth2/Social.vue"
export default component.exports